import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { IncomingBillService } from "@/services/IncomingBillService";
import { useToast } from "@/services/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateBillDialog',
  emits: ["bill-created"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const dialog = ref(false);
const billService = new IncomingBillService();
const { showToast } = useToast();

const form = ref({
  identifier: "",
  status: "",
  type: "ACCOMMODATION",
  amount: "",
});
const filters = ref({ accommodation: "", startDate: "", endDate: "" });
const bookingItems = ref<any[]>([]);
const selectedItems = ref<number[]>([]);

const parsedAmount = computed(() => {
  const value = Number(form.value.amount);
  return form.value.amount !== "" && Number.isFinite(value) ? value : null;
});

const isValid = computed(
  () =>
    !!form.value.identifier &&
    !!form.value.status &&
    !!form.value.type &&
    parsedAmount.value !== null &&
    selectedItems.value.length > 0
);

const statusOptions = [
  { label: "Esedékes", value: "DUE" },
  { label: "Fizetve", value: "PAID" },
  { label: "Törölve", value: "CANCELLED" },
  { label: "Lejárt", value: "OVERDUE" },
];

const typeOptions = [
  { label: "Szállás", value: "ACCOMMODATION" },
  { label: "IFA", value: "IFA" },
];

const itemHeaders = [
  { title: "Szálláshely", key: "accommodation" },
  { title: "Termék", key: "product" },
  { title: "Cég", key: "companyName" },
  { title: "Érkezés", key: "startDate" },
  { title: "Távozás", key: "endDate" },
  { title: "Létszám", key: "numberOfPeople", align: "end" as const },
  {
    title: "Bekerülési egységár",
    key: "grossPricePerPersonPerNight",
    align: "end" as const,
  },
  { title: "Foglalás ref.", key: "bookingPublicReference" },
];

const fetchBookingItems = async () => {
  const params: Record<string, string> = {};
  if (filters.value.accommodation)
    params.accommodation = filters.value.accommodation;
  if (filters.value.startDate) params.startDate = filters.value.startDate;
  if (filters.value.endDate) params.endDate = filters.value.endDate;
  bookingItems.value = (await billService.getBookingItems(params)) ?? [];
};

const submit = async () => {
  if (!isValid.value) return;
  try {
    await billService.create({
      identifier: form.value.identifier,
      status: form.value.status,
      type: form.value.type,
      amount: parsedAmount.value as number,
      bookingItemIds: selectedItems.value,
    });
    dialog.value = false;
    form.value = {
      identifier: "",
      status: "",
      type: "ACCOMMODATION",
      amount: "",
    };
    filters.value = { accommodation: "", startDate: "", endDate: "" };
    bookingItems.value = [];
    selectedItems.value = [];
    emit("bill-created");
    showToast("Számla létrehozva");
  } catch {
    showToast("Számla létrehozása sikertelen", "error");
  }
};

const __returned__ = { emit, dialog, billService, showToast, form, filters, bookingItems, selectedItems, parsedAmount, isValid, statusOptions, typeOptions, itemHeaders, fetchBookingItems, submit, computed, ref, watch, get IncomingBillService() { return IncomingBillService }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})